import React, { useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import parse from "html-react-parser";
import DOMPurify from "dompurify";
import { renderToStaticMarkup } from "react-dom/server"
import { AttachFile } from '@mui/icons-material';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import * as FileService from '../../../../../services/attachment.service';
import { PapiroConsole } from '../../../../../utils/papiroConsole';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '10px',
    padding: '12px 14px',
    border: '1px solid #ececec',
    borderLeft: '3px solid #FFB300',
    backgroundColor: '#fff',
    color: '#37474f',
    marginBottom: '10px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginBottom: 8,
  },
  headerLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: '#b78103',
  },
  content: {
    fontSize: 13.5,
    color: '#37474f',
    lineHeight: 1.5,
    wordBreak: 'break-word',
    '& p': { margin: '0 0 4px 0' },
  },
  attachmentsBlock: {
    marginTop: 10,
    paddingTop: 10,
    borderTop: '1px dashed #eee',
  },
  attachmentsLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: '#90a4ae',
    marginBottom: 6,
  },
  attachmentChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    maxWidth: '100%',
    padding: '5px 10px',
    marginRight: 6,
    marginBottom: 6,
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#fafafa',
    color: '#455a64',
    fontSize: 12.5,
    cursor: 'pointer',
    transition: 'all .15s ease',
    '&:hover': {
      backgroundColor: '#f1f8e9',
      borderColor: '#c5e1a5',
    },
  },
  attachmentName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 180,
  },
}));

function ChatNote(props) {
  const classes = useStyles();
  const intl = props.intl;
  const [content, setContent] = React.useState("")

  const t = (id, fallback) => {
    try { return intl ? intl.formatMessage({ id }) : fallback } catch (e) { return fallback }
  }

  const getFileName = (fileName) => {
    var file = fileName.substring(fileName.lastIndexOf('/') + 1);
    return file;
  }

  const getFile = async (hirerid, fileName, filerepositorymethod) => {
    props.setLoading(true);

    PapiroConsole.log(hirerid)
    PapiroConsole.log(fileName)
    PapiroConsole.log(filerepositorymethod)
    PapiroConsole.log("hirerid,fileName,filerepositorymethod")
    PapiroConsole.log(props)

    let url = await FileService.getFileByPath(hirerid, fileName, filerepositorymethod);
    props.setLoading(false);
    if (url && url.data && url.data.data && url.data.success) {
      window.open(`${url.data.data}`, '_blank');
    }
    else {
      props.setLoading(false);
      props.setOpenNotification(true);
      props.setNotificationMessage("Arquivo não encontrado");
      props.setNotificationVariant("error");
    }
  };

  useEffect(() => {
    let contentRendered = props.content
    if (props.content && props.content?.trim().startsWith("<p> &lt;h") || props.content?.trim().startsWith("<p>&lt;div")) {
      contentRendered = renderToStaticMarkup(props.content)

    } else if (props.content && props.content?.trim().startsWith("<div style=\"") || props.content?.trim().startsWith("<div dir=") || props.content?.trim().startsWith("<p>") || props.content?.trim().startsWith("<h1>") || props.content?.trim().startsWith("<h2>") || props.content?.trim().startsWith("<h3>")) {
      contentRendered = DOMPurify.sanitize(props.content)
    }
    setContent(contentRendered)
  }, [props.content])

  const hasAttachments = props.attachments && props.attachments.length > 0

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <StickyNote2OutlinedIcon style={{ fontSize: 16, color: '#FFB300' }} />
        <span className={classes.headerLabel}>{t("note", "Nota")}</span>
      </div>

      <div className={classes.content}>
        {content && parse(content)}
      </div>

      {hasAttachments && (
        <div className={classes.attachmentsBlock}>
          <div className={classes.attachmentsLabel}>{t("attachments", "Anexos")}</div>
          <div>
            {props.attachments.map((entry, index) => (
              <span
                key={index}
                className={classes.attachmentChip}
                title={getFileName(entry.attachment.description)}
                onClick={() => getFile(entry.attachment.hirerid, entry.attachment.path, entry.attachment.filerepositorymethod)}
              >
                <AttachFile style={{ fontSize: 15, color: '#90a4ae' }} />
                <span className={classes.attachmentName}>{getFileName(entry.attachment.description)}</span>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ChatNote
